<div class="p-3 flex flex-column flex-auto">

  <!-- ── Header ── -->
  <div class="flex align-items-center justify-content-between mb-3">
    <h3 style="margin:0;">Transaction Manager</h3>
    <div class="flex align-items-center gap-2">
      <button pButton type="button" class="p-button p-button-sm p-button-outlined"
              (click)="loadSales()" pTooltip="Refresh">
        <span class="pi pi-refresh"></span>
      </button>
      <button pButton type="button" class="p-button p-button-sm p-button-outlined"
              (click)="router.navigateByUrl('/till')">
        <span class="pi pi-angle-left" style="margin-right:4px;"></span>Back to Till
      </button>
    </div>
  </div>

  <!-- ── Filters ── -->
  <div class="surface-card p-3 shadow-2 border-round mb-3 flex align-items-center gap-2 flex-wrap">
    <p-calendar
      [(ngModel)]="selectedDate"
      [showIcon]="true"
      dateFormat="dd/mm/yy"
      [style]="{'height':'50px'}"
      (onSelect)="loadSales()">
    </p-calendar>
    <p-dropdown
      [options]="statusFilterOptions"
      [(ngModel)]="filterStatus"
      optionLabel="label"
      optionValue="value"
      [style]="{'width':'160px', 'height':'50px'}">
    </p-dropdown>
    <span class="p-input-icon-left" style="flex:1; min-width:120px;">
      <i class="pi pi-hashtag"></i>
      <input pInputText type="text" [(ngModel)]="filterID"
             style="width:100%; height:50px; padding-left:33px;"
             placeholder="Filter by ID…"/>
    </span>
    <span class="p-input-icon-left" style="flex:1; min-width:120px;">
      <i class="pi pi-table"></i>
      <input pInputText type="text" [(ngModel)]="filterTable"
             style="width:100%; height:50px; padding-left:33px;"
             placeholder="Filter by table…"/>
    </span>
    <span class="p-input-icon-left" style="flex:2; min-width:160px;">
      <i class="pi pi-tag"></i>
      <input pInputText type="text" [(ngModel)]="filterProduct"
             style="width:100%; height:50px; padding-left:33px;"
             placeholder="Filter by product…"/>
    </span>
    <button pButton type="button" class="p-button p-button-sm p-button-secondary p-button-outlined"
            style="height:50px; white-space:nowrap;"
            [disabled]="!filterStatus && !filterTable && !filterID && !filterProduct"
            (click)="clearFilters()">
      <span class="pi pi-times" style="margin-right:4px;"></span>Clear
    </button>
  </div>

  <!-- ── Transaction list ── -->
  <div class="surface-card p-4 shadow-2 border-round">
    <p-table #salesTable
      [value]="filteredSales"
      [paginator]="true" [rows]="20"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      [rowsPerPageOptions]="[10,20,50]"
      sortField="createddate" [sortOrder]="-1"
      responsiveLayout="scroll">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="createddate" style="width:8%">Time <p-sortIcon field="createddate"></p-sortIcon></th>
          <th pSortableColumn="tillsaleidhr" style="width:10%">Sale ID <p-sortIcon field="tillsaleidhr"></p-sortIcon></th>
          <th style="width:8%">Table</th>
          <th pSortableColumn="tillname" style="width:9%">Till <p-sortIcon field="tillname"></p-sortIcon></th>
          <th style="width:28%">Items</th>
          <th pSortableColumn="total" style="width:10%; text-align:right;">Total <p-sortIcon field="total"></p-sortIcon></th>
          <th style="width:10%; text-align:right;">Balance</th>
          <th style="width:9%; text-align:center;">Status</th>
          <th style="width:8%;"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-sale>
        <tr [ngStyle]="{'opacity': sale.voided ? '0.6' : '1', 'cursor': 'pointer'}"
            onmouseover="this.style.backgroundColor='#f5f5f5'"
            onmouseout="this.style.backgroundColor=''"
            (click)="openSale(sale)">
          <td>{{sale.createddate | date:'HH:mm'}}</td>
          <td style="font-weight:600;">{{sale.tillsaleidhr || '—'}}</td>
          <td>
            <div>{{sale.tablenumber || '—'}}</div>
            <div *ngIf="sale.tabname" style="font-size:11px; color:#888; margin-top:2px;">
              <span class="pi pi-user" style="margin-right:3px;"></span>{{sale.tabname}}
            </div>
          </td>
          <td style="font-size:12px; color:#666;">{{sale.tillname || '—'}}</td>
          <td style="max-width:260px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; font-size:13px;">
            {{getProductsSummary(sale)}}
          </td>
          <td style="text-align:right; font-weight:600;">{{sale.total | currency:CurrencySymbol}}</td>
          <td style="text-align:right;"
              [style.color]="getSaleOutstanding(sale) > 0.001 ? '#e74c3c' : getSaleOutstanding(sale) < -0.001 ? '#2980b9' : '#27ae60'">
            <ng-container *ngIf="!sale.voided">
              {{getSaleOutstanding(sale) | currency:CurrencySymbol}}
            </ng-container>
            <ng-container *ngIf="sale.voided">—</ng-container>
          </td>
          <td style="text-align:center;">
            <p-tag [value]="getSaleStatusLabel(sale)" [severity]="getSaleStatusSeverity(sale)" [style]="{'min-width':'90px','justify-content':'center'}"></p-tag>
          </td>
          <td style="text-align:center;">
            <button pButton type="button" class="p-button-sm p-button-outlined"
                    (click)="openSale(sale); $event.stopPropagation()"
                    pTooltip="Open">
              <span class="pi pi-pencil"></span>
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" style="text-align:center; padding:2.5rem; color:#aaa; font-size:16px;">
            <span class="pi pi-inbox" style="font-size:2rem; display:block; margin-bottom:8px;"></span>
            No transactions recorded today.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<!-- ═══════════════════════════════════════════════════════════════════════════
     Transaction detail dialog
═══════════════════════════════════════════════════════════════════════════ -->
<p-dialog
  *ngIf="selectedSale"
  [(visible)]="showDetailDialog"
  [modal]="true"
  [style]="{'width':'95vw','max-width':'1280px'}"
  [closable]="true"
  [draggable]="false"
  [resizable]="false">

  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between" style="width:100%;">
      <div class="flex align-items-center gap-3">
        <span style="font-size:18px; font-weight:700;">
          Transaction {{selectedSale.tillsaleidhr || selectedSale.tillsaleid}}
        </span>
        <span *ngIf="selectedSale.tablenumber" style="font-size:14px; color:#666;">
          <span class="pi pi-tag" style="margin-right:4px;"></span>Table {{selectedSale.tablenumber}}
        </span>
        <span *ngIf="selectedSale.tillname" style="font-size:14px; color:#666;">
          <span class="pi pi-desktop" style="margin-right:4px;"></span>{{selectedSale.tillname}}
        </span>
        <p-tag *ngIf="selectedSale.voided" value="VOIDED" severity="danger"></p-tag>
      </div>
    </div>
  </ng-template>

  <!-- ── Void banner ── -->
  <div *ngIf="selectedSale.voided"
       style="background:#fdecea; border:1px solid #f5c6c6; border-radius:6px; padding:12px 16px; margin-bottom:16px; display:flex; align-items:center; gap:10px;">
    <span class="pi pi-ban" style="font-size:20px; color:#c0392b;"></span>
    <div>
      <strong style="color:#c0392b;">This transaction has been voided.</strong>
      <span style="color:#666; font-size:13px; margin-left:8px;">No further changes can be made.</span>
    </div>
  </div>

  <!-- ── Overpaid banner ── -->
  <div *ngIf="isOverpaid && !selectedSale.voided"
       style="background:#fff8e1; border:1px solid #ffe082; border-radius:6px; padding:12px 16px; margin-bottom:16px; display:flex; align-items:center; justify-content:space-between; gap:10px;">
    <div class="flex align-items-center gap-2">
      <span class="pi pi-exclamation-triangle" style="font-size:20px; color:#f39c12;"></span>
      <div>
        <strong style="color:#e67e22;">Customer has overpaid by {{overpaidAmount | currency:CurrencySymbol}}</strong>
        <span style="color:#666; font-size:13px; display:block;">A refund should be issued to the customer.</span>
      </div>
    </div>
    <button pButton type="button" class="p-button-warning p-button-sm"
            (click)="openOverpaymentRefund()">
      Issue Refund
    </button>
  </div>

  <!-- ── Main grid ── -->
  <div class="grid" style="margin:0;">

    <!-- ── Left: Items ── -->
    <div class="col-12 lg:col-7" style="padding-right:1rem; border-right:1px solid #eee;">

      <h4 style="margin:0 0 10px;">Items Purchased</h4>

      <p-table [value]="selectedSale.products" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th style="width:30%">Product</th>
            <th style="width:24%">Options</th>
            <th style="width:9%; text-align:right;">Unit</th>
            <th style="width:17%; text-align:center;">Qty</th>
            <th style="width:12%; text-align:right;">Price</th>
            <th style="width:8%;"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr *ngIf="!item.disabled"
              [ngStyle]="{'opacity': item.qty === 0 ? '0.4' : '1'}">
            <td style="font-weight:500;">{{getItemName(item)}}</td>
            <td style="font-size:12px; color:#888;">
              <ng-container *ngIf="getItemOptions(item).length > 0; else noOpts">
                <span *ngFor="let opt of getItemOptions(item); let last = last">{{opt.name}}{{!last ? ', ' : ''}}</span>
              </ng-container>
              <ng-template #noOpts>—</ng-template>
            </td>
            <td style="text-align:right; color:#666;">{{getItemUnitPrice(item) | currency:CurrencySymbol}}</td>
            <td style="text-align:center;">
              <div *ngIf="!selectedSale.voided" class="flex align-items-center justify-content-center gap-2">
                <button pButton type="button" icon="pi pi-minus"
                        class="p-button-rounded p-button-outlined p-button-danger p-button-sm"
                        (click)="decreaseQty(item)"></button>
                <span style="min-width:24px; text-align:center; font-weight:700;">{{item.qty ?? 1}}</span>
                <button pButton type="button" icon="pi pi-plus"
                        class="p-button-rounded p-button-outlined p-button-success p-button-sm"
                        (click)="increaseQty(item)"></button>
              </div>
              <span *ngIf="selectedSale.voided" style="font-weight:700;">{{item.qty ?? 1}}</span>
            </td>
            <td style="text-align:right; font-weight:700;">{{item.price | currency:CurrencySymbol}}</td>
            <td style="text-align:center;">
              <button *ngIf="!selectedSale.voided"
                      pButton type="button" icon="pi pi-sliders-h"
                      class="p-button-rounded p-button-text p-button-sm"
                      pTooltip="Edit options"
                      (click)="editItemOptions(item)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="4" style="text-align:right; font-weight:700; font-size:15px; border-top:2px solid #ddd;">Order Total</td>
            <td style="text-align:right; font-weight:700; font-size:15px; border-top:2px solid #ddd;">{{orderTotal | currency:CurrencySymbol}}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- ── Sale metadata ── -->
      <div class="mt-3 p-3 surface-100 border-round" style="font-size:13px; color:#555; line-height:1.8;">
        <span style="margin-right:2rem;"><strong>Time:</strong> {{selectedSale.createddate | date:'dd/MM/yyyy HH:mm'}}</span>
        <span style="margin-right:2rem;"><strong>User:</strong> {{getUserName(selectedSale.userid)}}</span>
        <span *ngIf="selectedSale.tillname" style="margin-right:2rem;"><strong>Till:</strong> {{selectedSale.tillname}}</span>
        <span *ngIf="selectedSale.notes"><strong>Notes:</strong> {{selectedSale.notes}}</span>
      </div>
    </div>

    <!-- ── Right: Payments ── -->
    <div class="col-12 lg:col-5" style="padding-left:1rem;">

      <h4 style="margin:0 0 10px;">Payments</h4>

      <!-- Payment list -->
      <p-table [value]="selectedSale.payments" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th style="width:34%">Method</th>
            <th style="width:26%">Time</th>
            <th style="width:22%; text-align:right;">Amount</th>
            <th style="width:18%;"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pmt>
          <tr *ngIf="!pmt.disabled"
              [ngStyle]="{'background': pmt.amount < 0 ? '#fff3f3' : 'inherit'}">
            <td>
              <span *ngIf="pmt.amount < 0" class="pi pi-reply" style="margin-right:5px; color:#c0392b; font-size:11px;"></span>
              <span [style.color]="pmt.amount < 0 ? '#c0392b' : 'inherit'" [style.font-style]="pmt.amount < 0 ? 'italic' : 'normal'">
                {{pmt.method}}
              </span>
            </td>
            <td style="font-size:12px; color:#777;">{{pmt.paymentDate | date:'HH:mm dd/MM'}}</td>
            <td style="text-align:right; font-weight:700;"
                [style.color]="pmt.amount < 0 ? '#c0392b' : 'inherit'">
              {{pmt.amount | currency:CurrencySymbol}}
            </td>
            <td style="text-align:right;">
              <button *ngIf="pmt.amount > 0 && !selectedSale.voided"
                      pButton type="button"
                      class="p-button-sm p-button-outlined p-button-warning"
                      style="font-size:11px; padding:3px 8px;"
                      pTooltip="Issue refund for this payment"
                      (click)="openRefundFor(pmt)">
                Refund
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" style="text-align:center; color:#aaa; padding:1rem; font-size:13px;">No payments recorded.</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- ── Balance summary card ── -->
      <div class="mt-3 border-round p-3" style="background:#f8f9fa; border:1px solid #dee2e6;">
        <div class="flex justify-content-between mb-1" style="font-size:14px; color:#555;">
          <span>Order Total</span>
          <span style="font-weight:600;">{{orderTotal | currency:CurrencySymbol}}</span>
        </div>
        <div class="flex justify-content-between mb-2" style="font-size:14px; color:#555;">
          <span>Total Paid</span>
          <span style="font-weight:600;">{{paymentsTotal | currency:CurrencySymbol}}</span>
        </div>
        <div class="flex justify-content-between pt-2" style="border-top:2px solid #dee2e6; font-size:16px; font-weight:700;"
             [style.color]="outstanding > 0.001 ? '#e74c3c' : outstanding < -0.001 ? '#2980b9' : '#27ae60'">
          <span>
            <span *ngIf="outstanding > 0.001">Balance Due</span>
            <span *ngIf="outstanding < -0.001">Overpaid</span>
            <span *ngIf="outstanding >= -0.001 && outstanding <= 0.001">Settled</span>
          </span>
          <span>{{outstanding | currency:CurrencySymbol}}</span>
        </div>
      </div>

      <!-- Add Payment trigger button -->
      <button *ngIf="!selectedSale.voided && !showAddPayment"
              pButton type="button" class="p-button-sm p-button-outlined w-full mt-2"
              (click)="openAddPayment()">
        <span class="pi pi-plus" style="margin-right:6px;"></span>Add Payment
      </button>

      <!-- ──────────────────────────────────────────
           Action panels (one visible at a time)
      ─────────────────────────────────────────── -->

      <!-- Add Payment panel -->
      <div *ngIf="showAddPayment"
           class="mt-3 p-3 border-round shadow-1"
           style="border:1px solid #b3d4ff; background:#f0f7ff;">
        <div class="flex align-items-center justify-content-between mb-3">
          <h5 style="margin:0;">Add Payment</h5>
          <button pButton type="button" icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-sm"
                  (click)="cancelPaymentPanel()"></button>
        </div>
        <div class="field mb-3">
          <label class="font-medium block mb-1">Payment Method</label>
          <p-dropdown [options]="paymentTypes" [(ngModel)]="newPaymentType"
                      optionLabel="name" placeholder="Select method"
                      [style]="{'width':'100%'}"></p-dropdown>
        </div>
        <div class="field mb-3">
          <label class="font-medium block mb-1">Amount</label>
          <p-inputNumber [(ngModel)]="newPaymentAmount"
                         mode="currency" [currency]="CurrencySymbol"
                         [min]="0.01" [style]="{'width':'100%'}"></p-inputNumber>
        </div>
        <button pButton type="button" class="p-button-sm p-button-success w-full"
                (click)="confirmAddPayment()">
          <span class="pi pi-check" style="margin-right:6px;"></span>Confirm Payment
        </button>
      </div>

      <!-- Refund panel -->
      <div *ngIf="showAddRefund && refundTargetPayment"
           class="mt-3 p-3 border-round shadow-1"
           style="border:1px solid #ffd0d0; background:#fff8f8;">
        <div class="flex align-items-center justify-content-between mb-2">
          <h5 style="margin:0; color:#c0392b;">
            Issue Refund
          </h5>
          <button pButton type="button" icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-sm"
                  (click)="cancelRefundPanel()"></button>
        </div>
        <div style="font-size:13px; color:#555; margin-bottom:12px; padding:10px; background:#fff; border-radius:4px; border:1px solid #eee;">
          <div class="flex justify-content-between mb-1">
            <span>Original payment</span>
            <strong>{{refundTargetPayment.amount | currency:CurrencySymbol}}</strong>
          </div>
          <div class="flex justify-content-between">
            <span>Refund method</span>
            <strong>{{refundTargetPayment.method}}</strong>
          </div>
          <div style="margin-top:8px; font-size:11px; color:#999;">Refunds must be returned via the original payment method.</div>
        </div>
        <div class="field mb-3">
          <label class="font-medium block mb-1">Refund Amount</label>
          <p-inputNumber [(ngModel)]="refundAmount"
                         mode="currency" [currency]="CurrencySymbol"
                         [min]="0.01" [max]="refundTargetPayment.amount"
                         [style]="{'width':'100%'}"></p-inputNumber>
        </div>
        <div class="field mb-3">
          <label class="font-medium block mb-1">Reason <span style="font-weight:400; color:#aaa;">(optional)</span></label>
          <input pInputText [(ngModel)]="refundReason" style="width:100%;" placeholder="e.g. Item not available"/>
        </div>
        <button pButton type="button" class="p-button-sm p-button-danger w-full"
                (click)="confirmRefund()">
          Confirm Refund of {{refundAmount | currency:CurrencySymbol}}
        </button>
      </div>

      <!-- Overpayment refund panel -->
      <div *ngIf="showOverpaymentRefund"
           class="mt-3 p-3 border-round shadow-1"
           style="border:1px solid #ffe082; background:#fffde7;">
        <div class="flex align-items-center justify-content-between mb-2">
          <h5 style="margin:0; color:#e67e22;">
            Refund Overpayment
          </h5>
          <button pButton type="button" icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-sm"
                  (click)="cancelOverpaymentRefund()"></button>
        </div>
        <div style="font-size:13px; color:#555; margin-bottom:12px; padding:10px; background:#fff; border-radius:4px; border:1px solid #eee;">
          <div class="flex justify-content-between mb-1">
            <span>Overpaid by</span>
            <strong>{{overpaidAmount | currency:CurrencySymbol}}</strong>
          </div>
          <div class="flex justify-content-between">
            <span>Refund method</span>
            <strong>{{overpaymentRefundPayment?.method ?? '—'}}</strong>
          </div>
          <div style="margin-top:8px; font-size:11px; color:#999;">Refunds must be returned via the original payment method.</div>
        </div>
        <button pButton type="button" class="p-button-sm p-button-warning w-full"
                (click)="confirmOverpaymentRefund()">
          Refund {{overpaidAmount | currency:CurrencySymbol}} to Customer
        </button>
      </div>

      <!-- Void confirmation panel -->
      <div *ngIf="showVoidConfirm"
           class="mt-3 p-3 border-round shadow-1"
           style="border:2px solid #e74c3c; background:#fff5f5;">
        <div class="flex align-items-center gap-2 mb-2">
          <span class="pi pi-exclamation-triangle" style="color:#e74c3c; font-size:20px;"></span>
          <h5 style="margin:0; color:#c0392b;">Void This Transaction?</h5>
        </div>
        <p style="font-size:13px; color:#666; margin-bottom:16px;">
          This will mark the entire transaction as voided. This cannot be undone.
          <span *ngIf="paymentsTotal > 0"> Any payments made will remain on record — issue refunds separately if needed.</span>
        </p>
        <div class="flex gap-2">
          <button pButton type="button" class="p-button-sm p-button-danger flex-1"
                  (click)="confirmVoid()">
            <span class="pi pi-ban" style="margin-right:6px;"></span>Yes, Void Transaction
          </button>
          <button pButton type="button" class="p-button-sm p-button-outlined p-button-secondary"
                  (click)="cancelVoid()">
            Cancel
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Change table number ── -->
  <p-dialog [(visible)]="showChangeTable"
            [modal]="true"
            [style]="{'width':'380px'}"
            [closable]="false"
            [draggable]="false"
            [resizable]="false"
            header="Change Table Number">

    <p style="font-size:13px; color:#666; margin-bottom:12px;">
      Enter the table this transaction should be moved to.
    </p>

    <input pInputText type="text" [(ngModel)]="newTableNumber"
           placeholder="Table number"
           (keyup.enter)="confirmChangeTable()"
           style="width:100%;">

    <ng-template pTemplate="footer">
      <button pButton type="button" class="p-button-sm p-button-outlined p-button-secondary"
              (click)="cancelChangeTable()">
        Cancel
      </button>
      <button pButton type="button" class="p-button-sm"
              (click)="confirmChangeTable()">
        <span class="pi pi-check" style="margin-right:6px;"></span>Save Table Number
      </button>
    </ng-template>

  </p-dialog>

  <!-- ── Options editor ── -->
  <p-dialog *ngIf="showOptionsEditor && editingItem"
            [(visible)]="showOptionsEditor"
            [modal]="true"
            [style]="{'width':'440px'}"
            [closable]="false"
            [draggable]="false"
            [resizable]="false"
            [header]="'Edit Options — ' + getItemName(editingItem)">

    <!-- Currently selected options -->
    <div style="margin-bottom:16px;">
      <div style="font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:#6b7280; margin-bottom:8px;">
        Currently selected
      </div>
      <div *ngIf="(editingItem.selectedOptions ?? []).length === 0"
           style="color:#aaa; font-size:13px; padding:8px; background:#f9fafb; border-radius:6px; border:1px dashed #e5e7eb;">
        No options selected
      </div>
      <div *ngFor="let opt of (editingItem.selectedOptions ?? [])"
           class="flex align-items-center justify-content-between"
           style="padding:8px 10px; background:#eff6ff; border:1px solid #bfdbfe; border-radius:6px; margin-bottom:6px;">
        <span style="font-size:14px;">
          {{opt.name}}
          <span *ngIf="opt.price > 0" style="color:#059669; font-size:12px; margin-left:4px;">(+{{opt.price | currency:CurrencySymbol}})</span>
        </span>
        <button pButton type="button" icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger p-button-sm"
                pTooltip="Remove"
                (click)="toggleOption(opt)"></button>
      </div>
    </div>

    <!-- Available options -->
    <div *ngIf="availableOptions.length > 0">
      <div style="font-size:11px; font-weight:700; text-transform:uppercase; letter-spacing:0.06em; color:#6b7280; margin-bottom:8px;">
        Available options
      </div>
      <div *ngFor="let opt of availableOptions"
           class="flex align-items-center justify-content-between"
           style="padding:8px 10px; border-radius:6px; margin-bottom:6px; cursor:pointer;"
           [style.background]="isOptionSelected(opt) ? '#f0fdf4' : '#f9fafb'"
           [style.border]="isOptionSelected(opt) ? '1px solid #86efac' : '1px solid #e5e7eb'"
           (click)="toggleOption(opt)">
        <span style="font-size:14px;">
          {{opt.name}}
          <span *ngIf="opt.price > 0" style="color:#059669; font-size:12px; margin-left:4px;">(+{{opt.price | currency:CurrencySymbol}})</span>
        </span>
        <span class="pi" style="font-size:16px;"
              [class.pi-check-circle]="isOptionSelected(opt)"
              [class.pi-circle]="!isOptionSelected(opt)"
              [style.color]="isOptionSelected(opt) ? '#16a34a' : '#d1d5db'"></span>
      </div>
    </div>
    <div *ngIf="availableOptions.length === 0"
         style="color:#aaa; font-size:13px; padding:8px; background:#f9fafb; border-radius:6px; border:1px dashed #e5e7eb;">
      No options defined for this product.
    </div>

    <ng-template pTemplate="footer">
      <button pButton type="button" class="p-button-sm p-button-success"
              (click)="closeOptionsEditor()">
        <span class="pi pi-check" style="margin-right:6px;"></span>Done
      </button>
    </ng-template>
  </p-dialog>

  <!-- ── Dialog footer ── -->
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center w-full">
      <div class="flex gap-2">
        <button *ngIf="!selectedSale.voided"
                pButton type="button" class="p-button-outlined p-button-danger p-button-sm"
                (click)="requestVoid()">
          <span class="pi pi-ban" style="margin-right:6px;"></span>Void Transaction
        </button>
        <button *ngIf="!selectedSale.voided"
                pButton type="button" class="p-button-outlined p-button-sm"
                pTooltip="Reload this order into the till to add or change items"
                (click)="editInTill()">
          <span class="pi pi-shopping-cart" style="margin-right:6px;"></span>Edit in Till
        </button>
        <button *ngIf="!selectedSale.voided"
                pButton type="button" class="p-button-outlined p-button-sm"
                pTooltip="Move this transaction to a different table"
                (click)="openChangeTable()">
          <span class="pi pi-tag" style="margin-right:6px;"></span>Change Table
        </button>
      </div>
      <div class="flex gap-2">
        <button *ngIf="!selectedSale.voided"
                pButton type="button" class="p-button-sm p-button-success"
                (click)="saveChanges()">
          <span class="pi pi-save" style="margin-right:6px;"></span>Save Changes
        </button>
        <button pButton type="button" class="p-button-sm p-button-outlined p-button-secondary"
                (click)="showDetailDialog = false">
          Close
        </button>
      </div>
    </div>
  </ng-template>

</p-dialog>

<p-dialog header="Administrator Approval Required" [(visible)]="showAdminOverride" [modal]="true" [style]="{width:'420px'}" [draggable]="false" [resizable]="false" [closable]="false">
  <div style="display:flex; align-items:flex-start; gap:12px; padding:8px 0 16px;">
    <span class="pi pi-shield" style="font-size:28px; color:#d97706; flex-shrink:0; margin-top:2px;"></span>
    <span style="font-size:15px; line-height:1.5; color:#374151;">This action requires approval from a Venue Administrator. Select an administrator and enter their PIN to continue.</span>
  </div>
  <div style="display:flex; flex-direction:column; gap:12px;">
    <div>
      <label style="font-size:14px; font-weight:600; color:#374151; display:block; margin-bottom:6px;">Administrator</label>
      <p-dropdown
        [options]="adminOverrideUsers"
        [(ngModel)]="adminOverrideSelectedId"
        optionLabel="name"
        optionValue="userid"
        placeholder="Select administrator..."
        [style]="{width:'100%'}">
      </p-dropdown>
    </div>
    <div>
      <label style="font-size:14px; font-weight:600; color:#374151; display:block; margin-bottom:6px;">PIN</label>
      <input pInputText type="password" [(ngModel)]="adminOverridePin" placeholder="Enter PIN" style="width:100%;" (keyup.enter)="submitAdminOverride()" />
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" class="p-button p-element p-button-warning" (click)="submitAdminOverride()">
      <span class="pi pi-check-circle" style="margin-right:6px;"></span>Authorise
    </button>
    <button pButton pRipple type="button" class="p-button p-element p-button-secondary p-button-outlined" style="margin-left:8px;" (click)="cancelAdminOverride()">
      <span class="pi pi-times" style="margin-right:6px;"></span>Cancel
    </button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showTillNamePrompt" [modal]="true" [style]="{width: '360px'}" [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false">
  <div style="padding:24px;">
    <div style="text-align:center; margin-bottom:20px;">
      <div style="width:56px; height:56px; background:#fef3c7; border-radius:50%; display:flex; align-items:center; justify-content:center; margin:0 auto 12px;">
        <span class="pi pi-desktop" style="font-size:28px; color:#d97706;"></span>
      </div>
      <div style="font-size:18px; font-weight:700; color:#111; margin-bottom:4px;">Name This Till</div>
      <div style="font-size:15px; color:#6b7280;">Enter a name for this device (e.g. Bar, Front Desk). This is saved locally and only applies to this computer.</div>
    </div>
    <div style="margin-bottom:20px;">
      <label style="font-size:15px; font-weight:600; color:#374151; display:block; margin-bottom:6px;">Till Name</label>
      <input pInputText [(ngModel)]="tillNameInput" placeholder="e.g. Bar, Front Desk, Reception" style="width:100%;" (keyup.enter)="confirmTillName()" autofocus />
    </div>
    <button pButton pRipple type="button" class="p-button p-element p-button-success" style="width:100%; height:44px; font-weight:700;" (click)="confirmTillName()">
      <span class="pi pi-check" style="margin-right:6px;"></span>Save &amp; Continue
    </button>
  </div>
</p-dialog>
